import { useTranslation } from 'react-i18next';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const FunctionalityChartComponent = ({ data, label, typo, onRemove }) => {
    const { t } = useTranslation();
    const fontSize = 8;
    // Determines rotation angle for x-axis labels based on number of labels
    const rotationAngle = data.labels.length > 35 ? 90 : data.labels.length <= 6 ? 0 : 45;
    // Wraps long labels into multiple lines (every 15 characters)
    const wrapLabel = (text) => {
        return text.length > 15 ? text.match(/.{1,15}/g).join('\n') : text;
    };
    // Translates and formats chart data (labels and datasets)
    const updatedData = {
        ...data,
        labels: data.labels.map((label) => wrapLabel(t(label))),
        datasets: data.datasets.map((dataset) => ({
            ...dataset,
            label: t(dataset.label),
            borderColor: '#146f62',
            backgroundColor: 'rgba(20, 111, 98, 0.2)',
            pointBackgroundColor: '#146f62',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointHoverBackgroundColor: '#ee8013',
            pointHoverBorderColor: '#000',
            pointHoverBorderWidth: 3,
            pointHoverRadius: 7,
        })),
    };
    // Chart configuration options
    const options = {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            title: {
                text: t(label),
                font: {
                    size: fontSize,
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        let tooltipLabel = t(context.dataset.label || '');
                        const value = context.parsed.y !== null ? `${context.parsed.y}` : '';
                        return `${tooltipLabel}: ${value}`;
                    },
                },
            },
            legend: {
                position: 'top',
                labels: {
                    generateLabels: (chart) => {
                        return chart.data.datasets.map((dataset) => ({
                            text: t(dataset.label),
                            fillStyle: dataset.backgroundColor,
                            strokeStyle: dataset.borderColor,
                            hidden: !chart.isDatasetVisible(chart.data.datasets.indexOf(dataset)),
                            lineCap: dataset.borderCapStyle,
                            lineDash: dataset.borderDash,
                            lineDashOffset: dataset.borderDashOffset,
                            lineJoin: dataset.borderJoinStyle,
                            lineWidth: dataset.borderWidth,
                            pointStyle: dataset.pointStyle,
                        }));
                    },
                },
            },
        },
        scales: {
            x: {
                beginAtZero: true,
                ticks: {
                    autoSkip: false,
                    callback: (value, index) => t(data.labels[index]),
                    font: {
                        size: fontSize,
                    },
                    maxRotation: rotationAngle,
                    minRotation: rotationAngle,
                },
            },
            y: {
                min: 0,
                max: 100,
                beginAtZero: true,
                stacked: true,
                ticks: {
                    font: {
                        size: fontSize,
                    },
                },
            },
        },
    };
    return { t, fontSize, rotationAngle, wrapLabel, updatedData, options };
};
export default FunctionalityChartComponent;
